import { List } from 'immutable';
import { FIELDS } from '../constants/fields';
export const isNoDataState = (visualization, isDrilldown) => {
  if (!visualization) {
    return true;
  }
  if (isDrilldown) {
    return visualization.getIn(['data', 'primary', 'data'], List()).length === 0;
  }
  const anyStepHasContacts = visualization.getIn(['data', 'primary', 'data'], List()).some(pathSegment => pathSegment.get(FIELDS.COUNT) > 0);
  return !anyStepHasContacts;
};